import type { InternalDashboardActions } from '@store/reducers/dashboard/actions'
import { ChangesSavedNotification } from '@storeOld/reducers/notification'
import { call, delay, put } from 'redux-saga/effects'

import API from '@/api'

const REQUEST_TIMEOUT = 1000
export function* renameRequest({
  payload,
}: ReturnType<typeof InternalDashboardActions.renameRequest>) {
  const { workspaceId, title } = payload
  yield delay(REQUEST_TIMEOUT)
  // @ts-expect-error
  yield call(API.Team.update, {
    teamId: workspaceId,
    payload: { name: title },
  })

  yield put(ChangesSavedNotification)
}
